function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgContactDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 200 200",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.5
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M26,18L171,99L25,181L71,99L26,18Z",
    style: {
      fill: "none",
      stroke: "#191238",
      strokeWidth: "20.77px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71,99L171,99",
    style: {
      fill: "none",
      stroke: "#191238",
      strokeWidth: "20.77px"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactDark);
export default __webpack_public_path__ + "static/media/contactDark.9aae0a80dca679a9ff6515abb7745c9d.svg";
export { ForwardRef as ReactComponent };